module.exports = __webpack_public_path__ + "img/album_std.fe846925.jpg";